import { JobOffer, JobOfferResponse } from '@dinosband/bv-main-schema/dist/types'
import { waitFor } from '@dinosband/dbi-utils'

import { JobOfferResponseSubscriber, JobOfferSubscriber } from '../../subscriber'
import { DataCenter_ProxyType } from '../abstract'
import { JOB_OFFER_UPDATED } from './const'

export class MyJobOffers extends DataCenter_ProxyType<number, JobOffer> {

  _store: Record<number, JobOffer> = {}
  _offerSubscriber!: JobOfferSubscriber
  _responseSubscriber!: JobOfferResponseSubscriber

  async init () {
    const mainStore = this.mainStore
    this._offerSubscriber = new JobOfferSubscriber(mainStore, mainStore.userId, undefined, (value) => { this.onJobOfferUpdate(value) })
    this._responseSubscriber = new JobOfferResponseSubscriber({ mainStore }, (value) => { this.onJobOfferResponseUpdate(value) })
    await Promise.all([
      this._offerSubscriber.start(),
      this._responseSubscriber.start(),
      this.retrieve(),
    ])
  }

  cleanup () {
    super.cleanup()
    this._offerSubscriber?.cleanup()
    this._responseSubscriber?.cleanup()
  }

  jobOffer (jobOfferId: number) {
    return this.get(jobOfferId)
  }

  jobOffersOfChannel (channelId: number) {
    return this.values.filter((i) => i.channelId === channelId)
  }

  onReconnected () {
    this.retrieve()
  }

  protected async query (jobOfferId: number) {
    const result = await this.mainStore.readJobOfferGraph(jobOfferId)
    return result
  }

  async retrieve () {
    try {
      const results = await this.mainStore.readMyJobOffers()
      for (const i of results) {
        this.set(i.id, i)
        this.pubsub.publish(JOB_OFFER_UPDATED, i)
      }
      return results
    } catch (e) {
      console.error(e)
    }
  }

  async wait (jobOfferId: number, timeout = 5_000) {
    await waitFor(() => this.has(jobOfferId), timeout)
    return this.get(jobOfferId)
  }

  private onJobOfferUpdate (value: JobOffer) {
    const jobOffer = Object.assign(this.get(value.id) ?? {}, value)
    this.set(jobOffer.id, jobOffer)
    this.pubsub.publish(JOB_OFFER_UPDATED, jobOffer)
  }

  private onJobOfferResponseUpdate (response: JobOfferResponse) {
    if (response.clientUserId !== this.mainStore.userId) {
      return
    }
    let jobOffer = this.get(response.jobOfferId)
    if (!jobOffer) {
      jobOffer = response.jobOffer
    }
    const responses = (jobOffer.responses ?? []).filter((i) => i.id != response.id)
    responses.push(response)
    jobOffer.responses = responses
    this.set(jobOffer.id, jobOffer)
    this.pubsub.publish(JOB_OFFER_UPDATED, jobOffer)
  }

}